import type { BuildQueryParamsInAppV6, BuildQueryParamsInAppV7 } from '~/types/template';

const GEMX_CRO = 'GemX CRO';

export function convertPathnameToTitle(pathname = '') {
  const segments = pathname.split('/').filter(Boolean);
  const title = segments.map(capitalizeFirstLetter).join(' ');
  const titleSegments = `${title} - ${GEMX_CRO}`;

  return title ? titleSegments : GEMX_CRO;
}

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase();
};

export const buildQueryParamsInAppForV6 = ({
  version,
  pageId,
  pageType,
}: BuildQueryParamsInAppV6) => {
  return `app/builder/${version}?pageId=${pageId}&type=${pageType}&version=${version}`;
};

export const buildQueryParamsInAppForV7 = ({
  version,
  pageId,
  themeId,
  pageType,
  type,
  gemXFeature,
  campaignId,
}: BuildQueryParamsInAppV7) => {
  let url = `app/builder/${version}?pageId=${pageId}&themeId=${themeId}&type=${type}&pageType=${pageType}&version=${version}`;
  if (gemXFeature) url += `&gemXFeature=${gemXFeature}`;
  if (campaignId) url += `&campaignId=${campaignId}`;

  return url;
};
